module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "#/004toc#ch01"
    }
  }, [_c('i', [_vm._v("Chapter 1")]), _c('br'), _c('span', {
    staticClass: "red"
  }, [_vm._v("SNACKS, NUTS & OLIVES")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITE")]), _vm._v("-S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IZE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REATS FOR")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCASIONS")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-14.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#sect1",
      "id": "sect_1"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("spiced popcorn & pumpkin seeds")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-16.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("serves 8 to 10")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This addictive snack is a great combination of spice, salt, and crunch, and awakens the palate perfectly for sips of red or white wine. Set a few bowls around the room when you entertain for easy nibbling, and watch how quickly they empty. Salty snacks like this one and the "), _c('a', {
    attrs: {
      "href": "#/007chapter01#page_18"
    }
  }, [_vm._v("Piquant Roasted Chickpeas")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/007chapter01#page_20"
    }
  }, [_vm._v("Chile-Lime Peanuts")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/007chapter01#page_21"
    }
  }, [_vm._v("Roasted Mixed Nuts")]), _vm._v(", pair well with light, fruity reds and rosés, and whites such as Chardonnay, Sauvignon Blanc, and Pinot Grigio.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Pumpkin Seeds:")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tsp salt")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp paprika")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Pinch of garlic powder")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Pinch of cayenne pepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Freshly ground black pepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 cups/230 g raw hulled pumpkin seeds")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tbsp olive oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Popcorn:")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("3 tbsp corn oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup/85 g popcorn")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Kosher salt")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To make the pumpkin seeds: In a small bowl, stir together the salt, paprika, garlic powder, cayenne, and black pepper to taste and set aside."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Combine the pumpkin seeds and olive oil in a large bowl and toss well to coat. Transfer the pumpkin seeds to a large nonstick frying pan and place over high heat. Toast, shaking the pan and tossing the seeds constantly, until browned and puffed, about 5 minutes. Return to the oiled bowl, add the spice mixture, and toss well again to coat evenly."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To make the popcorn: Heat a heavy-bottomed saucepan with a tight-fitting lid over medium heat. Add the corn oil and popcorn and shake the pan to spread the popcorn and oil evenly over the bottom of the pan. Partially cover the pan to allow the steam to escape, and cook the popcorn, constantly shaking the pan, until the popping begins, quickens, and then stops."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove from the heat, sprinkle with salt, and toss to coat. Add the popcorn to the bowl with the spiced pumpkin seeds and toss until well combined. Serve at once in a bowl or basket lined with a paper or cloth napkin.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#sect2",
      "id": "sect_2"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("piquant roasted chickpeas")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("serves 6 to 8")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These tasty, savory chickpeas are a snap to make and require nothing more than a few pantry items you should always have on hand: canned chickpeas, olive oil, and spices. The symphony of spices here is well matched with a red wine with lots of fruit, as rich a Chardonnay as you like, or grassy Sauvignon Blancs and Pinot Grigios.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Two 15"), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v("-oz/445-g cans chickpeas, rinsed and drained")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp paprika")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp ground coriander")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp ground cumin")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Pinch of cayenne pepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("3 tbsp olive oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Kosher salt and freshly ground black pepper")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 400°F/200°C/gas 6. Put the chickpeas in a large bowl."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small bowl, stir together the paprika, coriander, cumin, and cayenne until well mixed. Sprinkle over the chickpeas. Add the olive oil and toss well to coat evenly."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spread the chickpeas in a single layer on a rimmed baking sheet/tray and sprinkle with salt and black pepper. Roast, stirring occasionally, until the chickpeas are crisp and golden, about 30 minutes."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove from the oven and transfer to paper towels/absorbent paper to drain. Let cool completely. Taste and adjust the seasoning, if necessary, and serve."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Make-Ahead:")]), _vm._v(" The chickpeas can be made up to 4 hours in advance. Store in an airtight container at room temperature.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#sect3",
      "id": "sect_3"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("sweet & spicy mixed nuts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("serves 6 to 8")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This delicious mix of roasted nuts has a nice salty-sweet coating of sugar, five spice powder, and kosher salt. Try these with Merlot or Cabernet Sauvignon.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 cups/230 g raw unsalted peanuts, pecans, almonds, or cashews, or any combination")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("3 tbsp sugar")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 tbsp five spice powder")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tbsp corn or canola oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Kosher salt")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 350°F/180°C/gas 4."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the nuts, sugar, five spice powder, oil, and salt in a large bowl and toss together to coat well."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spread the nuts in a single layer on a rimmed baking sheet/tray and toast in the oven, shaking the pan occasionally, until the coating is dry and the nuts are lightly browned and fragrant, 15 to 20 minutes. Let cool completely before serving. Season with additional salt, if necessary."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Make-Ahead:")]), _vm._v(" The nuts will keep in an airtight container for up to 2 weeks. If they lose their crispness, reheat in an oven at 250°F/120°C/gas "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" for about 15 minutes, then let cool.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#sect4",
      "id": "sect_4"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("chile-lime peanuts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("serves 10 to 12")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just a touch of lime and salt, mingled with the scent of cumin and the kick of cayenne, elevates everyday peanuts to a sublime snack. Be sure to let the peanuts cool completely before serving. Pair with light, fruity reds and rosés, or any icy cold dry white wine.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("4 cups/450 g unsalted peanuts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("3 tbsp fresh lime juice")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 tbsp olive oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tbsp paprika")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tsp ground cumin")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 tsp kosher salt")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tsp cayenne pepper")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 250°F/120°C/gas "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(". Put the peanuts in a large bowl."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small bowl, whisk together the lime juice, olive oil, paprika, cumin, salt, and cayenne. Pour the spice mixture over the peanuts and toss well to coat evenly."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spread the peanuts in a single layer on a rimmed baking sheet/tray and toast in the oven, shaking the pan occasionally, until the coating is dry and the nuts are lightly browned and fragrant, 25 to 30 minutes. Let cool completely before serving."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Make-Ahead:")]), _vm._v(" The peanuts will keep in an airtight container for up to 2 weeks. If they lose their crispness, reheat in an oven at 250°F/120°C/gas "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" for about 15 minutes, then let cool.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#sect5",
      "id": "sect_5"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("roasted mixed nuts")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("serves 6 to 8")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Blend and toast your spices to give these roasted nuts rich fragrance and flavor. They’re always a welcome snack for friends who drop in for a glass of wine. Salt and crunch are pleasantly offset by light reds and dry or semidry whites; also try a buttery Chardonnay to complement the rich oils in the nuts.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp ground cumin")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp chili powder")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp garlic salt")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp ground ginger")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp ground cinnamon")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Pinch of cayenne pepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tbsp olive oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 cup/115 g raw unsalted pecans")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 cup/115 g raw unsalted almonds")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Kosher salt")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 325°F/165°C/gas 3."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small bowl, stir together all of the spices. Heat the olive oil in a small frying pan over medium heat. Add the spice mixture and cook, stirring constantly, until well blended and fragrant, about 3 minutes."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Combine the pecans and almonds in a large bowl. Add the spice mixture and toss well to coat evenly."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spread the nuts in a single layer on a rimmed baking sheet/tray and toast in the oven, shaking the pan occasionally, until the nuts are lightly browned and the spices are fragrant, 12 to 15 minutes. Remove from the oven and sprinkle with salt while still warm. Let cool completely before serving."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Make-Ahead:")]), _vm._v(" The nuts will keep in an airtight container for up to 1 week. If they lose their crispness, reheat in an oven at 250°F/120°C/gas "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" for about 15 minutes, then let cool.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#sect6",
      "id": "sect_6"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("deviled eggs niçoise")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-22.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("makes 12 deviled eggs")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("People are crazy for deviled eggs, among the most classic of picnic finger foods. Outdoors or in more elegant settings inside, whenever I serve them, they disappear quickly. This version springs from the hard-boiled eggs that are one of the definitive ingredients in "), _c('i', [_vm._v("salade Niçoise,")]), _vm._v(" and piles on other delicious flavors from that beloved French dish. These are wonderful with a chilled Muscadet or rosé.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("6 large eggs")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("One 6-oz/170-g can water-or oil-packed tuna, drained")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 tbsp chopped Niçoise olives")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tbsp capers, rinsed and drained")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tbsp olive oil")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 tsp balsamic vinegar")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tsp Dijon mustard")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Freshly ground black pepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("12 small water- or salt-packed anchovy fillets (optional)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Finely chopped pimentos and red bell pepper/capsicum, peppadews, or green beans for garnish")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the eggs in a large saucepan and add cold water to cover. Bring to a gentle boil over medium-high heat. When the water just begins to boil, remove the pot from the heat and cover tightly. Let the eggs stand, covered, for 30 minutes. Drain the eggs and rinse under cold running water. Pat the eggs dry and let cool completely."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When the eggs are cool enough to handle, peel them and cut in half lengthwise. Gently scoop the yolks into a large bowl, being careful not to break the whites. Arrange the egg white halves, cavity-side up, on a platter and set aside."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the tuna, olives, and capers to the bowl with the yolks and mix well with a fork, flaking the tuna finely and mashing the yolks until smooth. In a small bowl, whisk together the olive oil, vinegar, and mustard. Add the vinaigrette to the yolk mixture and stir to blend well. Season with pepper."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Using a small spoon, mound the filling in the cavities of the egg white halves, dividing it evenly. Top each with an anchovy fillet (if using) and garnish with the pimentos. Serve chilled or at room temperature."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('b', [_vm._v("Make-Ahead:")]), _vm._v(" The deviled eggs can be made up to 3 hours in advance. Cover loosely with plastic wrap/cling film and refrigerate. Serve chilled or remove from the refrigerator 30 minutes before serving and serve at room temperature.")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("Wine Bite Idea")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Try these delicious filling variations for deviled eggs with fish, or create your own. Be sure to use good-quality mayo, or "), _c('span', {
    attrs: {
      "href": "#/013chapter07#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("homemade")]), _vm._v(". To the egg yolks, add:")]), _vm._v(" "), _c('ul', {
    staticClass: "disc"
  }, [_c('li', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup/120 ml mayonnaise, 1 tsp Dijon mustard, "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup/40 g each finely chopped anchovies and celery, and freshly ground black pepper to taste."), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup/120 ml mayonnaise, 1 tsp Dijon mustard, "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup/40 g finely chopped fresh lump crabmeat, and fresh lemon juice, salt, and freshly ground black pepper to taste."), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup/120 ml mayonnaise, 1 tsp Dijon mustard, "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup/40 g finely chopped smoked salmon, 2 tbsp finely minced fresh dill, and fresh lemon juice to taste. Garnish each with a small dill sprig."), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup/120 ml mayonnaise, 1 tsp Dijon mustard, and fresh lemon juice, salt, and freshly ground black pepper to taste. Garnish each with a small cooked and chilled shrimp/prawn.")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#sect7",
      "id": "sect_7"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("marinated cerignola olives")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("serves 10 to 12")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Big, beautiful Cerignolas are an olive lover’s dream. Rich with a ripe olive flavor, they come in green, red, and black varieties; I like to sauté a colorful combination of all three with garlic and fresh herbs. They are delicious served warm or at room temperature, or spoon them into a jar with extra-virgin olive oil to cover and keep them on hand in the refrigerator. They’re wonderful on their own or served with cheese and "), _c('i', [_vm._v("salumi.")]), _vm._v(" Serve with a Merlot or Sangiovese.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tbsp extra-virgin olive oil, plus "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup/120 ml")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 cloves garlic, thinly sliced")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 cups/500 g mixed Cerignola olives, rinsed and drained")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("6 pieces lemon peel, each about 1"), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" in/4 cm long and "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" in/12 mm wide")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tsp chopped fresh rosemary")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 tsp chopped fresh thyme")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Pinch of red pepper flakes (optional)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("Freshly ground black pepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Heat the 1 tbsp olive oil in a skillet over medium heat. Add the garlic and sauté until softened, about 2 minutes. Add the olives, lemon peel, rosemary, thyme, and red pepper flakes (if using). Season with black pepper. Cook gently, stirring occasionally, to allow the flavors to blend, about 10 minutes. Remove from the heat and let cool. Transfer the olives to a serving bowl."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup/120 ml olive oil over the olives and serve."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Make-Ahead:")]), _vm._v(" The olives will keep, tightly covered in the refrigerator, for up to 3 weeks.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#sect8",
      "id": "sect_8"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("warm citrus & fennel olives")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("serves 6 to 8")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When olives are warmed in a skillet with a bit of oil, they take on robust and meaty flavor. Add a squeeze of fresh orange juice and slivers of fresh fennel and their scent and taste are unforgettable. You may want to double or triple this recipe. The deep flavor of these olives goes very well with a full-bodied Cabernet Sauvignon.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("1 cup/250 g mixed olives (see Note), rinsed and drained, 1 tbsp juice reserved")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("2 tbsp fresh orange juice")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_vm._v("4 pieces orange peel, each about 1 in/2.5 cm long and "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" in/6 mm wide")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" bulb fennel, trimmed, cored, and thinly sliced lengthwise")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp fennel seed")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" tsp extra-virgin olive oil")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the olives and reserved juice in a skillet. Add the orange juice, orange peel, fennel, fennel seed, and olive oil and place over medium-low heat. Cook, stirring occasionally, until the juices begin to simmer and then reduce slightly."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer to a small serving bowl and serve warm, or remove from the heat, cover, and reheat the olives gently just before serving. Serve with toothpicks."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" There are dozens of varieties of olives that differ in size, color, and flavor. Use any combination of best-quality cured olives for this recipe. Following are a few suggestions for the mix. Be sure to have small bowls handy for olive pits.")]), _vm._v(" "), _c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("Cerignola (Italian): Large oval-shaped with a sweetish flavor. Red, green, or black in color.")]), _vm._v(" "), _c('li', [_vm._v("Gaeta (Italian): Black or brown, small, and wrinkled.")]), _vm._v(" "), _c('li', [_vm._v("Ligurian (Italian): Black or brown. The black ones are very flavorful.")]), _vm._v(" "), _c('li', [_vm._v("Niçoise (French): Very small and dark brown or black, with a large pit.")]), _vm._v(" "), _c('li', [_vm._v("Nyons (French): Small and known for their reddish-brown color.")]), _vm._v(" "), _c('li', [_vm._v("Picholine (French): Small and medium-green in color.")]), _vm._v(" "), _c('li', [_vm._v("Kalamata (Greek): Purple-black, almond shaped, and shiny. Available in a variety of sizes.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54eb1b29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007chapter01.vue
// module id = 72
// module chunks = 0